import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { WebapiService } from '../webapi.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { PreloaderService } from '../preloader.service';
import { DateUtilService } from '../date-utils';
@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss']
})
export class ApplicationComponent implements OnInit {
  applicationList: any;
  candidate: any;
  imageUrl:any;
  countList: any;
  formExcelData: any={};
  formExcelDatav2: any={};
  clientList: any;
  smallModalContent: any ;
  clientprocessList: any;
  filter:any={};
  total:number;
  p:number = 1;
  totalAppCount: any;
  loading:boolean;
  teamName:any
  loginType: any;
  mangList: any;
  statusData:any={};
  approveCounter: boolean =true;
  inviteUrl:any;
  statusArr:any;
  finalStatusArr: any=[];
  reportUrl: any;
  isLoading: boolean;
  reportData:any={};
  reportLogData:any={};
  filterData:any={};
  loginId: any;
  fileString: any;
  pdfCounter: boolean = false;
  imageCounter: boolean = false;
  fileData:any={};
  insuffChecksArray:any=[];
  reportChecksData: any[] = [];
  draggedReportIndex: number | null = null;
  isReportDrawerOpen: boolean = false;

  selectedFiles: any;
  progressInfos = [];
  isBulkUploading: boolean = false;
  bulkCurrentIndex: number = 0;
  bulkTotalFiles: number = 0;
  userList: any=[];
  selectedFilesZip: File[]= [];
  logList: any=[];
  arrInsuff: any=[];
  currentDocumentName: string = 'Document';
  currentFileUrl: string = '';
  modalRef: NgbModalRef | null = null;

  constructor(public dateUtil: DateUtilService,private WebApiService:WebapiService,private activatedRoute:ActivatedRoute,
    private router:Router, private modalService: NgbModal,private sanitizer: DomSanitizer,private spinner:PreloaderService) {
      this.imageUrl = this.WebApiService.imageUrl;
      this.inviteUrl = this.WebApiService.inviteUrl;
      this.reportUrl = this.WebApiService.reportUrl;
     }

  ngOnInit(): void {
    // Read user identity from localStorage (survives refresh) with sessionStorage fallback
    this.teamName = localStorage.getItem('teamName') || sessionStorage.getItem('teamName');
    this.loginType = localStorage.getItem('type') || sessionStorage.getItem('type');
    this.loginId = localStorage.getItem('loginId') || sessionStorage.getItem('loginId');
    if(this.loginType == 3){
      this.statusArr = ['ACCEPTED','REJECTED'];
    }
    else{
      this.statusArr = ['NEW','INPROGRESS','QC','COMPLETED','STOPPED','ACCEPTED','REJECTED'];
    }
    this.filter = {
      pageNo:1,
      size:10,
      status:'',
      search: sessionStorage.getItem('activeSearchApp') || '',
      clientId:'',
      created:'',
      assignProcess:'',
      assignTo:''
    }
    this.getClient();
    if(this.loginType == 1){
      if(this.filter.search) { this.searchApp(null); } else { this.getAllApplication(); }
      this.getApplicationCountByStatus();
    }
    else if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
      this.filter.perm = 'all'
      if(this.filter.search) { this.searchApp(null); } else { this.getAllApplicationV2(); }
      this.getApplicationCountByStatusV2();
      this.getAllManager();
    }
    else if(this.loginType ==4 && this.teamName == "Processing Team"){
      if(this.filter.search) { this.searchApp(null); } else { this.getAllApplicationByEmp(); }
      this.getApplicationCountByStatusByEmp();
    }
    else if(this.loginType == 6){
      let client = sessionStorage.getItem("addedId");
      let process = sessionStorage.getItem("assignProcess");
      this.formExcelData.process = process;
      this.filter.assignTo = this.loginId;
      if(this.filter.search) { this.searchApp(null); } else { this.getAllApplication(); }
      this.getApplicationCountByStatus();
      this.getProcessV2(client);
      this.getUserByType(7)
    }
    else if(this.loginType == 7){
      let client = sessionStorage.getItem("addedId");
      let process = sessionStorage.getItem("assignProcess");
      this.formExcelData.process = process;
      this.filter.assignTo = this.loginId;
      if(this.filter.search) { this.searchApp(null); } else { this.getAllApplication(); }
      this.getApplicationCountByStatus();
      this.getProcessV2(client);
      this.getUserByType(7)
    }
    else if(this.loginType == 3){
      this.filter.clientId = this.loginId
      if(this.filter.search) { this.searchApp(null); } else { this.getAllApplication(); }
      this.getApplicationCountByStatus();
      this.getProcessV2(this.loginId);
      this.getUserByType('SPOCTM')
    }
  }

  ngOnDestroy(): void {
    sessionStorage.removeItem('activeSearchApp');
  }

  isArray(value:[]):boolean {
    return Array.isArray(value);
  }
  isObject(value:any):boolean {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }
  isString(value:any):boolean {
    return typeof value === 'string' && value !== null && !Array.isArray(value);
  }
  containsProof(str:''):boolean {
    return str.includes('.proof');
  }
  getKeys(obj: object): string[] {
    return Object.keys(obj);
  }
  formatDateV2(dateString:any){
    const date = new Date(dateString);

    // Convert to IST (UTC + 5:30)
    const istOffset = 5.5 * 60 * 60 * 1000; // Offset in milliseconds
    const istDate = new Date(date.getTime() - istOffset);

    // Format the date parts
    const day = String(istDate.getDate()).padStart(2, '0');
    const month = String(istDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = istDate.getFullYear();
    const hours = String(istDate.getHours()).padStart(2, '0');
    const minutes = String(istDate.getMinutes()).padStart(2, '0');

    // Return formatted string
    return `${day}/${month}/${year}, ${hours}:${minutes}`;
  }

  getResp(e:any){
   if(e.target.value == "APPROVED"){
    this.approveCounter = true;
   }
   else{
    this.approveCounter = false;
   }
  }
  setStatus(data:any){
    if(data.status == 'INSUF'){
      if(this.arrInsuff.length == 0){
        alert('Please Select Check for remark');
        return
      }
    }

    data.team = this.teamName;
    data.performBy = this.loginId;
    this.WebApiService.insertApplication(data).subscribe((res: any) => {
      console.log(res);
      if(res.status == "ok"){
        alert(res.msg);
        this.modalService.dismissAll();
        let added = sessionStorage.getItem('addedId');
        if(this.loginId == '670654c31539eee3796d1872' || added == '670654c31539eee3796d1872'){
          this.trackUser(this.loginId,'insuf_response','Update the Insuf Response');
        }
        if(this.loginType == 1){
          if(this.filter.search) { this.searchApp(null); } else { this.getAllApplication(); }
          this.getApplicationCountByStatus();
        }
        else if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
          if(this.filter.search) { this.searchApp(null); } else { this.getAllApplicationV2(); }
          this.getApplicationCountByStatusV2();
          this.getAllManager();
        }
        else if(this.loginType ==4 && this.teamName == "Processing Team"){
          if(this.filter.search) { this.searchApp(null); } else { this.getAllApplicationByEmp(); }
          this.getApplicationCountByStatusByEmp();
        }
        else if(this.loginType == 3){
          this.filter.clientId = this.loginId;
          if(this.filter.search) { this.searchApp(null); } else { this.getAllApplication(); }
          this.getApplicationCountByStatus();
        }
      }
      else{
        alert(res.msg);
      }

    });
  }
  

  downloadFile(){
    let added = sessionStorage.getItem('addedId');
    if(this.loginId == '670654c31539eee3796d1872' || added == '670654c31539eee3796d1872'){
      this.trackUser(this.loginId,'download_data','Download the File in panel');
    }
  }
  checkForDoubleCase(){

  }

  getAllManager(){
    this.WebApiService.getAllManager().subscribe((res:any)=>{
      
      this.mangList = res.user;
    });
  }

  inviteCandidate(id:any,candName:any,clientName:any,email:any){
   let val = {
    appId:id,
    candName:candName,
    clientName:clientName,
    url:this.inviteUrl,
    candidateEmail:email,
    performedBy:this.loginId
   }
   this.WebApiService.inviteEmail(val).subscribe((res:any)=>{
    console.log(res);
    if(res.status == "ok"){
      alert(res.msg);
    }
    else{
      alert(res.msg);
    }
  });
  }

  changeAppStatus(appId:any,e:any){
    //  console.log(appId,status);
     let val = {
       _id:appId,
       status:e.target.value,
       performBy:this.loginId
     }
     this.WebApiService.insertApplication(val).subscribe((res: any) => {
      console.log(res);
      if(res.status == "ok"){
        alert(res.msg);
        if(this.loginType == 1){
          if(this.filter.search) { this.searchApp(null); } else { this.getAllApplication(); }
          this.getApplicationCountByStatus();
        }
        else if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
          if(this.filter.search) { this.searchApp(null); } else { this.getAllApplicationV2(); }
          this.getApplicationCountByStatusV2();
        }
        else if(this.loginType ==4 && this.teamName == "Processing Team"){
          if(this.filter.search) { this.searchApp(null); } else { this.getAllApplicationByEmp(); }
          this.getApplicationCountByStatusByEmp();
        }
        else if(this.loginType == 3){
          this.filter.clientId = this.loginId;
          if(this.filter.search) { this.searchApp(null); } else { this.getAllApplication(); }
          this.getApplicationCountByStatus();
        }
      }
      else{
        alert(res.msg);
      }

    });

  }

  genrateReportV2(data:any){
    if(data.temp == "IR"){
      data.interimDate = data.date;
      data.result = data.result;
    }
    else if(data.temp == "SR"){
      data.supplimentryDate = data.date;
      data.result = data.result;

    }
    else if(data.temp == "FR"){
      data.finalDate = data.date;
      data.result = data.result;

    }

    data.performBy = this.loginId;
    
    // Add selected and reordered checks
    data.reportChecksData = this.reportChecksData.filter(chk => chk.selected);
    
   this.WebApiService.insertApplication(data).subscribe((res: any) => {

    if(res.status == "ok"){
      this.genrateReport(data);
    }
    else{
      alert(res.msg);
    }

  });

  }

//   genrateReportV3(data: any) {
//   if (data.temp == "IR") {
//     data.interimDate = data.date;
//   } else if (data.temp == "SR") {
//     data.supplimentryDate = data.date;
//   } else if (data.temp == "FR") {
//     data.finalDate = data.date;
//   }

//   data.performBy = this.loginId;

//   // First insert application
//   this.WebApiService.insertApplication(data).subscribe((res: any) => {
//     if (res.status == "ok") {
//       // Call createReportLog only after insertApplication success
//       this.WebApiService.createReportLog(data).subscribe((reportRes: any) => {
//         if (reportRes.status == "ok") {
//           alert(reportRes.msg);
//           this.genrateReport(data._id, data.temp);  // Call only once here
//         } else {
//           alert(reportRes.msg);
//         }
//       });
//     } else {
//       alert(res.msg);
//     }
//   });
// }

  uploadReportV2(data:any){
  
  if(!data.temp){
    alert('Please Select Report Type'); 
    return
  }
  if(!data.result){
    alert('Please Select Report Color'); 
    return
  }
  if(!data.file){
    alert('Please upload Pdf Report Before Submit!!');
    return;
  }
  data.performedBy=this.loginId;
     this.WebApiService.createReportLog(data).subscribe((res: any) => {
    
    if(res.status == "ok"){
      alert(res.msg);
      this.modalService.dismissAll();
      if(this.loginType == 1){
        if(this.filter.search) { this.searchApp(null); } else { this.getAllApplication(); }
        this.getApplicationCountByStatus();
      }
      else if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
        if(this.filter.search) { this.searchApp(null); } else { this.getAllApplicationV2(); }
        this.getApplicationCountByStatusV2();
      }
      else if(this.loginType ==4 && this.teamName == "Processing Team"){
        if(this.filter.search) { this.searchApp(null); } else { this.getAllApplicationByEmp(); }
        this.getApplicationCountByStatusByEmp();
      }
      else if(this.loginType == 3){
        this.filter.clientId = this.loginId;
        if(this.filter.search) { this.searchApp(null); } else { this.getAllApplication(); }
        this.getApplicationCountByStatus();
      }
    }
    else{
      alert(res.msg);
    }

  });
  }

  genrateReport(data:any){
    // this.isLoading =true;
    this.spinner.show();
   let val = {
    appId:data._id,
    temp:data.temp,
    reportChecksData: data.reportChecksData,
    performedBy:this.loginId
   }
   this.WebApiService.genrateReport(val).subscribe((res: any) => {
    if(res.status == "ok"){
    this.spinner.hide();
    let logData = {
      applicationId:data._id,
      temp:data.temp,
      performedBy:this.loginId,
      result:data.result,
      file:res.path,
      date:data.date
     }
     console.log(logData);
    this.createReportLog(logData);
      // this.isLoading = false;
      alert("Report Generated");
      this.modalService.dismissAll();
      this.isReportDrawerOpen = false;
      if(this.loginType == 1){
        if(this.filter.search) { this.searchApp(null); } else { this.getAllApplication(); }
        this.getApplicationCountByStatus();
      }
      else if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
        if(this.filter.search) { this.searchApp(null); } else { this.getAllApplicationV2(); }
        this.getApplicationCountByStatusV2();
      }
      else if(this.loginType ==4 && this.teamName == "Processing Team"){
        if(this.filter.search) { this.searchApp(null); } else { this.getAllApplicationByEmp(); }
        this.getApplicationCountByStatusByEmp();
      }
      else if(this.loginType == 3){
        this.filter.clientId = this.loginId;
        if(this.filter.search) { this.searchApp(null); } else { this.getAllApplication(); }
        this.getApplicationCountByStatus();
      }
      window.open(`${this.reportUrl}${res.path}`,"_blank");
    }
    else{
      alert("something went wrong");
      this.spinner.hide();
    }
  });

  }

  createReportLog(data:any){
    this.WebApiService.createReportLog(data).subscribe((res: any) => {
      if(res.status == "ok"){
        console.log(res.msg);
      }
    });
  }

  getClient() {
    this.WebApiService.getAllClient().subscribe((res: any) => {
      this.clientList = res.user;
    });
  }

  getAllApplication(){
    this.loading =true;
    this.WebApiService.getAllApplication(this.filter).subscribe((res:any)=>{
   this.applicationList = res.data;
   this.total = res.total;
   this.loading =false
   for (const ap of this.applicationList) {
    let today:any = new Date();
    let otherDate:any = new Date(ap.tatEnd);
    let diffTime = Math.abs(today - otherDate);
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (today > otherDate) {
      ap.tatStatus = `${diffDays} days delayed`;
    } else if (today < otherDate) {
      ap.tatStatus = `${diffDays} days left`;
    } else {
      ap.tatStatus = `last day of tat`;
    }
     }

     if(this.applicationList[0]?._id){
       this.getAppById(this.applicationList[0]?._id);
     }

    })
  }

  getAllApplicationV2(){
    this.loading =true;
    this.WebApiService.getAllApplicationInit(this.filter).subscribe((res:any)=>{
   this.applicationList = res.data;
   this.total = res.total;
   this.loading =false
   for (const ap of this.applicationList) {
    let today:any = new Date();
    let otherDate:any = new Date(ap.tatEnd);
    let diffTime = Math.abs(today - otherDate);
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (today > otherDate) {
      ap.tatStatus = `${diffDays} days delayed`;
    } else if (today < otherDate) {
      ap.tatStatus = `${diffDays} days left`;
    } else {
      ap.tatStatus = `last day of tat`;
    }
     }

     if(this.applicationList[0]?._id){
       this.getAppById(this.applicationList[0]?._id);
     }
    })
  }

  getAllApplicationByEmp(){
    this.loading =true;
    this.WebApiService.getAllApplicationByEmp(this.filter).subscribe((res:any)=>{
    //  console.log(res);
   this.applicationList = res.data;
   this.total = res.total;
   this.loading =false
   for (const ap of this.applicationList) {
    let today:any = new Date();
    let otherDate:any = new Date(ap.tatEnd);
    let diffTime = Math.abs(today - otherDate);
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (today > otherDate) {
      ap.tatStatus = `${diffDays} days delayed`;
    } else if (today < otherDate) {
      ap.tatStatus = `${diffDays} days left`;
    } else {
      ap.tatStatus = `last day of tat`;
    }
     }

     if(this.applicationList[0]?._id){
       this.getAppById(this.applicationList[0]?._id);
     }
    //  console.log(this.applicationList,'uu');

    })
  }

  onTableDataChange(event: any) {
    this.filter.pageNo = event;
    if(this.loginType == 1){
      this.getAllApplication();
    }
    if(this.loginType == 3){
      this.getAllApplication();
    }
    if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
      this.getAllApplicationV2();
    }
    if(this.loginType == 4){
      this.getAllApplicationByEmp();
    }
    this.p = event;
  //   window.scrollTo({
  //    top: 0,
  //    behavior: 'smooth'
  //  });
 }
  getApplicationCountByStatus(){
    this.WebApiService.getApplicationCountByStatus(this.filter).subscribe((res:any)=>{
    
    if(res.data.length){
      const obj={};
      for (const key of res.data[0]?.count_per_field) {
            obj['ALL'] = res.total
            obj[key.k] = key.v;
       }
       this.countList = obj;
    }
  })
  }

  getApplicationCountByStatusV2(){
    let val = {}
    if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
      val = {
        perm:'all'
      }
    }
    this.WebApiService.getApplicationCountByStatusInit(val).subscribe((res:any)=>{
    
    if(res.length){
      const obj={};
      for (const key of res[0]?.count_per_field) {
            obj['ALL'] = res[0]?.total_count
            obj[key.k] = key.v;
       }
       this.countList = obj;
    }
  })
  }

  getApplicationCountByStatusByEmp(){
    this.WebApiService.getApplicationCountByStatusByEmp().subscribe((res:any)=>{
    
    if(res.length){
      const obj={};
      for (const key of res[0]?.count_per_field) {
            obj['ALL'] = res[0]?.total_count
            obj[key.k] = key.v;
       }
       this.countList = obj;
    }
  })
  }

  selectInsuffChecks(e:any){
    if (e.target.checked == true) {
      this.arrInsuff.push(e.target.value);
    }else{
      var index = this.arrInsuff.indexOf(e.target.value);
      this.arrInsuff.splice(index, 1);
    }
    console.log(this.arrInsuff);
    this.statusData.typeOfChecks = this.arrInsuff;
  }

  getAppById(id:any){
    this.loading =true
    this.WebApiService.getAppById(id).subscribe((res:any)=>{
      this.candidate = [res.data];
      this.insuffChecksArray = res?.data?.checksData;
      console.log(this.insuffChecksArray,'--');
     this.logList = res.logs;
     this.loading=false;
     let shCopy = this.statusArr.slice();
     let index = shCopy.indexOf(res.status);
     if(index >= 0){
      shCopy.splice(index, 1)
      this.finalStatusArr = shCopy;
     }
     else{
      this.finalStatusArr = this.statusArr;
     }
      })
  }

  getApplicationByStatus(status:any){
   this.filter.status = status;
   this.WebApiService.getApplicationByStatus(this.filter).subscribe((res:any)=>{
   this.applicationList =res.data
   this.total = res.total
   for (const ap of this.applicationList) {
    let today:any = new Date();
    let otherDate:any = new Date(ap.tatEnd);
    let diffTime = Math.abs(today - otherDate);
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (today > otherDate) {
      ap.tatStatus = `${diffDays} days delayed`;
    } else if (today < otherDate) {
      ap.tatStatus = `${diffDays} days left`;
    } else {
      ap.tatStatus = `last day of tat`;
    }
     }
     if(this.applicationList[0]?._id){
      this.getAppById(this.applicationList[0]?._id);
    }
    else{
      this.candidate = [];
    }
   })
  }

  async applyFilter(data:any){
    this.filter.clientId = data.clientId;
    this.filter.created = data.created;
    await this.searchCount();
    this.WebApiService.getApplicationByFilter(this.filter).subscribe((res:any)=>{
    this.applicationList =res.data
    this.total = res.total
    for (const ap of this.applicationList) {
     let today:any = new Date();
     let otherDate:any = new Date(ap.tatEnd);
     let diffTime = Math.abs(today - otherDate);
     let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
     if (today > otherDate) {
       ap.tatStatus = `${diffDays} days delayed`;
     } else if (today < otherDate) {
       ap.tatStatus = `${diffDays} days left`;
     } else {
       ap.tatStatus = `last day of tat`;
     }
      }
      if(this.applicationList[0]?._id){
        this.getAppById(this.applicationList[0]?._id);
      }
      else{
        this.candidate = [];
      }
    })
   }

  async searchApp(e:any){
   if (e && e.target && typeof e.target.value !== 'undefined') {
     this.filter.search = e.target.value;
   }
   sessionStorage.setItem('activeSearchApp', this.filter.search || '');

   if(this.filter.search){
    await this.searchCount()
    this.WebApiService.getApplicationBySearch(this.filter).subscribe((res:any)=>{
      this.applicationList =res.data
      this.total = res.total
      for (const ap of this.applicationList) {
        let today:any = new Date();
        let otherDate:any = new Date(ap.tatEnd);
        let diffTime = Math.abs(today - otherDate);
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (today > otherDate) {
          ap.tatStatus = `${diffDays} days delayed`;
        } else if (today < otherDate) {
          ap.tatStatus = `${diffDays} days left`;
        } else {
          ap.tatStatus = `last day of tat`;
        }
         }
         if(this.applicationList[0]?._id){
          this.getAppById(this.applicationList[0]?._id);
        }
        else{
          this.candidate = [];
        }
      })
   }
   else{
    if(this.loginType == 1){
      this.getAllApplication();
      this.getApplicationCountByStatus();
    }
    else if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
      this.getAllApplicationV2();
      this.getApplicationCountByStatusV2();
    }
    else if(this.loginType ==4 && this.teamName == "Processing Team"){
      this.getAllApplicationByEmp();
      this.getApplicationCountByStatusByEmp();
    }
   }
  }

  searchCount(){
    this.WebApiService.getCountBySearch(this.filter).subscribe((res:any)=>{
      console.log(res.length);
      const obj={};
      if(res.length > 0){
        for (const key of res[0].count_per_field) {
          obj['ALL'] = res[0].total_count
          obj[key.k] = key.v;
     }
     this.countList = obj;
      }
      else{
        obj['ALL'] = 0;
        obj['NEW'] = 0;
        obj['INPROGRESS'] = 0;
        obj['QC'] = 0;
        obj['COMPLETED'] = 0;
        obj['STOPPED'] = 0;
        this.countList = obj;

      }

      })
  }

  // onFilesSelected(event: any) {
  //   this.selectedFilesZip = event.target.files;
  //   if(this.selectedFilesZip.length > 0) {
  //     this.uploadZips3();
  //   }
  // }

  onFilesSelected(event: any) {
    this.selectedFilesZip = event.target.files;
    
    // Validate if only ZIP files are selected
    const invalidFiles = Array.from(this.selectedFilesZip).filter((file: File) => {
      return !file.name.toLowerCase().endsWith('.zip');
    });
  
    if (invalidFiles.length > 0) {
      alert('Only ZIP files are allowed.');
      this.selectedFilesZip = []; // Clear invalid selection
      event.target.value = '';
      return;
    }
  
    if (this.selectedFilesZip.length > 0) {
      this.uploadZips3();
    }
  }

  uploadZips3(){
    this.spinner.show();
    const formDataToSend = new FormData();
    for (let file of this.selectedFilesZip) {
      formDataToSend.append('files', file, file.name);
    }

    this.WebApiService.uploadZipS3(formDataToSend).subscribe((res: any) => {
      if(res.status == "ok"){
       this.spinner.hide();
        this.formExcelData.supportingFiles = res.uploadedFileNames;
        alert('file uploaded successfully');
       }
       else{
         this.spinner.hide();
        alert("something went wrong")

       }
    });
  }

  onExcelSelected(event: any) {
  const selectedFiles = event.target.files;

  // Validate if only Excel files are selected
  const invalidFiles = Array.from(selectedFiles).filter((file: File) => {
    return !(file.name.toLowerCase().endsWith('.xls') || file.name.toLowerCase().endsWith('.xlsx'));
  });

  if (invalidFiles.length > 0) {
    alert('Only Excel files (.xls, .xlsx) are allowed.');
    event.target.value = ''; // Clear invalid selection
    return;
  }

  if (selectedFiles.length > 0) {
    this.uploadExcel(selectedFiles);
  }
}

uploadExcel(files: FileList) {
  this.spinner.show();
  const formData = new FormData();
  for (let file of Array.from(files)) {
    formData.append('file', file, file.name);
  }

  this.WebApiService.uploadImage(formData).subscribe((res: any) => {
    this.spinner.hide();
    if (res.status === "ok") {
      this.formExcelData.file = res.imageName;
      alert('File uploaded successfully');
    } else {
      alert("Something went wrong");
    }
  });
}

  uploadCsv(e:any){
    this.spinner.show();
    const formData = new FormData();
    formData.append('image',e.target.files[0]);
    this.WebApiService.uploadImage(formData).subscribe((res: any) => {
       if(res.status == "ok"){
        this.spinner.hide();
         this.formExcelData.file = res.imageName
         alert('file uploaded successfully');
        }
        else{
          this.spinner.hide();
         alert("something went wrong")

        }
     });
  }
  uploadCsvv2(e:any){
    const formData = new FormData();
    formData.append('image',e.target.files[0]);
    this.WebApiService.uploadImage(formData).subscribe((res: any) => {
       if(res.status == "ok"){
         this.formExcelDatav2.file = res.imageName
         alert('file uploaded successfully');
        }
        else{
         alert("something went wrong")
        }
     });
  }

  uploadData(data:any){
    if(this.loginType == 3){
      data.client = this.loginId;
      data.addedBy = this.loginId;
    }
    else if(this.loginType == 6 ){
      let client = sessionStorage.getItem('addedId')
      data.client = client;
      data.addedBy = this.loginId;
    }
    else{
      data.addedBy = this.loginId;
    }
    data.type = this.loginType;
    this.WebApiService.uploadApplicationExcel(data).subscribe((res: any) => {
      console.log(res);
      if(res.status == "ok"){
        let added = sessionStorage.getItem('addedId');
        if(this.loginId == '670654c31539eee3796d1872' || added == '670654c31539eee3796d1872'){
          this.trackUser(this.loginId,'bulk_upload_case','Bulk Case uploaded in panel');
        }
        alert('Bulk Upload Success');
        location.reload();
      }
      else{
        alert('Upload Failed');
      }
    });
  }

  trackUser(empId:any,event:any,ed:any){
    let val = {
      employeeId:empId,
      eventType:event,
      eventDescription:ed
    }
    this.WebApiService.trackUser(val).subscribe((res:any)=>{
       console.log(res);
       
    });
  }

  uploadDataV2(data:any){
    this.WebApiService.updateApplicationExcel(data).subscribe((res: any) => {
      console.log(res);
      if(res.status == "ok"){
        alert('Bulk Upload Success');
        location.reload();
      }
      else{
        alert('Upload Failed');
      }
    });
  }

  getProcess(e:any){
   let pro = this.clientList.filter((x=>x._id == e.target.value));
   this.clientprocessList = pro[0].processList;

  }
  getProcessV2(e:any){
    setTimeout(() => {
      if(this.clientList.length > 0){
        let pro = this.clientList.filter((x=>x._id == e));
        this.clientprocessList = pro[0].processList;
      }
    }, 1000);

   }
   getProcessV3(e:any){
    setTimeout(() => {
      let pro = this.clientList.filter((x=>x._id == e));
      this.clientprocessList = pro[0].processList;
    }, 1000);
   }
  resetFilter(){
    this.filterData = {};
  }



  openSmallModal( smallModalContent ) {
    this.modalService.open( smallModalContent, { size : 'sm' } );
  }
  openSmallModalV2( statusMContent,id:any,data:any ) {
    this.statusData._id = id
    this.statusData.candidateName = data.candidateName;
    this.statusData.fatherName = data.fatherName;
    this.statusData.dob = data.dob;
    this.statusData.candidateName = data.candidateName;

    this.modalService.open( statusMContent, { size : 'sm' } );
  }
  openSmallModalV3( reportMcontent,id:any ) {
    this.reportData._id = id;
    const activeCand = this.candidate.find((c: any) => c._id === id) || this.candidate[0];
    if (activeCand && activeCand.checksData) {
      this.reportChecksData = JSON.parse(JSON.stringify(activeCand.checksData));
      this.reportChecksData.forEach((chk: any) => chk.selected = true);
    } else {
      this.reportChecksData = [];
    }
    this.isReportDrawerOpen = true;
  }

  onReportDragStart(event: DragEvent, index: number) {
    this.draggedReportIndex = index;
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', index.toString());
    }
  }

  onReportDragOver(event: DragEvent, index: number) {
    event.preventDefault();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move';
    }
  }

  onReportDrop(event: DragEvent, dropIndex: number) {
    event.preventDefault();
    if (this.draggedReportIndex !== null && this.draggedReportIndex !== dropIndex) {
      const item = this.reportChecksData.splice(this.draggedReportIndex, 1)[0];
      this.reportChecksData.splice(dropIndex, 0, item);
    }
    this.draggedReportIndex = null;
  }

  openSmallModalV4( reportMcontentV2,id:any ) {
    this.reportLogData.applicationId = id
    this.modalService.open( reportMcontentV2, { size : 'sm' } );
  }

  getImage(name:any,mdl:any){
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
    this.currentDocumentName = name;
    this.modalRef = this.modalService.open(mdl, { windowClass: 'custom-left-modal', backdrop: false, keyboard: false });
    let url = `${this.imageUrl}${name}`;
    this.currentFileUrl = url;
    this.fileString = '';
    if(name.includes('.pdf')){
      this.pdfCounter = true;
      this.imageCounter = false;
      this.fileString = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    else if(name.includes('.jpg') || name.includes('.jpeg') || name.includes('.JPG') || name.includes('.JPEG') || name.includes('.png') || name.includes('.PNG') ){
      this.imageCounter = true;
      this.pdfCounter = false
      this.fileString = url;
    }
  }

  openInNewTab(){
    if (this.currentFileUrl) {
      window.open(this.currentFileUrl, '_blank');
    }
  }

  deleteApplication(e:any){
    let prompt = confirm("Are you sure you want to delete");
    if(prompt){
      let val = {
        _id:e,
        isActive:false
      }
      this.WebApiService.insertApplication(val).subscribe((res: any) => {
       
       if(res.status == "ok"){
         alert(res.msg);
         if(this.loginType == 1){
           this.getAllApplication();
           this.getApplicationCountByStatus();
         }
         else if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
           this.getAllApplicationV2();
           this.getApplicationCountByStatusV2();
         }
         else if(this.loginType ==4 && this.teamName == "Processing Team"){
           this.getAllApplicationByEmp();
           this.getApplicationCountByStatusByEmp();
         }
         else if(this.loginType == 3){
           this.filter.clientId = this.loginId
           this.getAllApplication();
           this.getApplicationCountByStatus();
         }
       }
       else{
         alert(res.msg);
       }

     });
    }
  }

  getUserByType(id:any){
    this.WebApiService.getUserByType(id).subscribe((res:any)=>{
      

      this.userList = res.data
    });
  }
  lockApplication(e:any){
    let prompt = confirm("Are you sure you want to lock");
    if(prompt){
      let val = {
        _id:e,
        isActive:false
      }
      this.WebApiService.insertApplication(val).subscribe((res: any) => {
       
       if(res.status == "ok"){
         alert(res.msg);
         if(this.loginType == 1){
           this.getAllApplication();
           this.getApplicationCountByStatus();
         }
         else if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
           this.getAllApplicationV2();
           this.getApplicationCountByStatusV2();
         }
         else if(this.loginType ==4 && this.teamName == "Processing Team"){
           this.getAllApplicationByEmp();
           this.getApplicationCountByStatusByEmp();
         }
         else if(this.loginType == 3){
           this.filter.clientId = this.loginId
           this.getAllApplication();
           this.getApplicationCountByStatus();
         }
       }
       else{
         alert(res.msg);
       }

     });
    }


  }

  uploadReportFile(e:any){
    if(e.target.files[0].type == 'application/pdf'){
      this.spinner.show();
      const formData = new FormData();
      formData.append('file',e.target.files[0]);
      formData.append('type','return');
      this.WebApiService.uploadMedia(formData).subscribe((res: any) => {
         if(res.status == "ok"){
          this.spinner.hide();
           alert('upload success');
           this.reportLogData.file = res.uploadedFileName;
          }
          else{
          this.spinner.hide();
           alert("something went wrong")
          }
       });
    }
    else{
      alert('Only Pdf File allowed!!');
      e.target.value = '';
    }

  }

  SubmitReport(id:any){
    this.fileData._id = id;
    this.WebApiService.insertApplication(this.fileData).subscribe((res: any) => {
      if(res.status == "ok"){
        alert(res.msg);
        this.getAppById(id);
       }
       else{
        alert("something went wrong")
       }
    });
  }

  uploadMultipleReportFile(event:any) {
    this.progressInfos = [];
    if (event.target.files.length > 20) {
      alert("You can only upload a maximum of 20 files at once.");
      event.target.value = '';
      this.selectedFiles = null;
      return;
    }
    this.selectedFiles = event.target.files;
  }

  async SubmitMultipleReport() {
    if (!this.selectedFiles || this.selectedFiles.length === 0) {
      alert("Please select files first");
      return;
    }

    this.isBulkUploading = true;
    this.bulkTotalFiles = this.selectedFiles.length;
    const failedFiles: string[] = [];

    for (let i = 0; i < this.selectedFiles.length; i++) {
        this.bulkCurrentIndex = i + 1;
        // Extract the full filename stem (without extension) as empId
        // e.g. "RSM01245350-Final.pdf" → "RSM01245350-Final" (full stem sent to backend)
        const fileName = this.selectedFiles[i].name.replace(/\.[^.]+$/, '');
        try {
            await this.uploadMultipleFilesAsync(this.selectedFiles[i], fileName);
            console.log(`Uploaded (${i + 1}/${this.selectedFiles.length}): ${this.selectedFiles[i].name}`);
        } catch (err) {
            console.error(`Error uploading file: ${this.selectedFiles[i].name}`, err);
            failedFiles.push(this.selectedFiles[i].name);
        }
    }

    this.isBulkUploading = false;

    if (failedFiles.length === 0) {
      alert(`Bulk upload successful! All ${this.bulkTotalFiles} files uploaded.`);
    } else {
      alert(`Upload completed with ${failedFiles.length} failure(s):\n${failedFiles.join('\n')}`);
    }

    // Soft refresh — reload data without destroying the session
    this.selectedFiles = null;
    if (this.loginType == 1 || this.loginType == 3) {
      this.getAllApplication();
      this.getApplicationCountByStatus();
    } else if (this.loginType == 4 && this.teamName == 'Case Initiation Team') {
      this.getAllApplicationV2();
      this.getApplicationCountByStatusV2();
    } else if (this.loginType == 4) {
      this.getAllApplicationByEmp();
      this.getApplicationCountByStatusByEmp();
    }
  }

  uploadMultipleFilesAsync(file: any, empId: any): Promise<any> {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('empId', empId);
    formData.append('url', this.imageUrl);
    formData.append('type', 'return');
    return new Promise((resolve, reject) => {
      this.WebApiService.uploadMultipleImage(formData).subscribe(
        (res: any) => resolve(res),
        (error: any) => reject(error)  // Propagate errors so the caller catch block fires
      );
    });
  }

}

        // -------------------------------------------------
        // ------------------------
        // ---- if the above code stops working use the below code
        // ------------------------------

// SubmitMultipleReport() {
//   for (let i = 0; i < this.selectedFiles.length; i++) {
//      let fileName = this.selectedFiles[i].name.split(".")[0];
//      fileName = fileName.split('-')[0];
//      this.uploadMultipleFiles(this.selectedFiles[i],fileName,i);
//     console.log('media uploaded-${i+1}');
//   }

// }

// uploadMultipleFiles(file,empId:any,index:any){
//   const formData = new FormData();
//   formData.append('image',file);
//   formData.append('empId',empId);
//   formData.append('url',this.imageUrl);
//   formData.append('type','return');
//   this.WebApiService.uploadMultipleImage(formData).subscribe((res: any) => {
//     if(this.selectedFiles.length == index+1){
// alert("bulk upload Success");
//   location.reload();
//     }
//     
//   },((error)=>{
//     console.log(error);

// }));
// }
